export namespace Setting {
  /** 主题模式 */
  export enum Theme {
    /** 酷黑模式 */
    cool,
    /** 科技蓝模式 */
    bakos,
    /** 日间模式 */
    plaster,
  }

  /** 赔率模式 */
  export enum Decimal {
    /** 欧洲盘模式 */
    european,
    /** 美国盘模式 */
    american,
    /** 香港盘模式 */
    hongKong,
    /** 印尼盘模式 */
    indonesian,
    /** 马来西亚盘模式 */
    malaysian,
    /** 分数盘模式 */
    fractional,
  }

  /** 余额类型 */
  export enum BalanceType {
    /** 现金余额 */
    cash = 'cash',
    /** 奖金余额 */
    bonus = 'bonus',
  }

  /** 盘口展示模式 */
  export enum MarketMode {
    /** 标准模式，只展示一个盘口 */
    STANDARD = 0,
    /** 三盘模式，展示三个盘口 */
    THREE_MODE = 1,
    /** 专业模式，展示六个盘口 */
    PROFESSIONAL = 2,
  }
}

export type SettingCookie = {
  lang: string;
  theme: Setting.Theme;
  decimal: Setting.Decimal;
  currency: string;
  currencyView: string;
  balanceType: Setting.BalanceType;
  marketMode: Setting.MarketMode;
};

export const SETTING_COOKIE_KEYS = [
  'lang',
  'theme',
  'decimal',
  'currency',
  'currencyView',
  'balanceType',
  'marketMode',
] as const satisfies (keyof SettingCookie)[];
